"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenInput = void 0;
const helper_text_1 = require("@pulse-web-ui/helper-text");
const input_1 = require("@pulse-web-ui/input");
const options_1 = require("@pulse-web-ui/options");
const suggestions_1 = require("@pulse-web-ui/suggestions");
const react_1 = __importStar(require("react"));
const components_1 = require("./components");
const token_input_styles_1 = require("./token-input.styles");
require("./token-input.types");
const DELETE_KEY_CODE = 8;
const SPACE_KEY_CODE = 32;
const TokenInput = ({ options, value, onChange, label, error, hintObject, disabled, isStaticOptions, suggestions, noMargin, testId = 'tokenInput', }) => {
    var _a, _b;
    const cachedOptionsList = (0, react_1.useMemo)(() => (options === null || options === void 0 ? void 0 : options.map((option) => (Object.assign(Object.assign({}, option), { selected: (value === null || value === void 0 ? void 0 : value.some(({ value: optionValue }) => optionValue === option.value)) || false })))) || [], [options, value]);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [optionsList, setOptionsList] = (0, react_1.useState)(cachedOptionsList);
    const [searchValue, setSearchValue] = (0, react_1.useState)('');
    const [hasFocusedStyle, setHasFocusedStyle] = (0, react_1.useState)(false);
    const inputRef = (0, react_1.useRef)(null);
    const tokenInputContainerRef = (0, react_1.useRef)(null);
    const rowRef = (0, react_1.useRef)(null);
    const refRowContent = (0, react_1.useRef)(null);
    const optionsContainerRef = (0, react_1.useRef)(null);
    const isOptionsLoading = !(options === null || options === void 0 ? void 0 : options.length);
    const filteredOptions = (0, react_1.useMemo)(() => !!searchValue
        ? optionsList.filter(({ label }) => label.toLowerCase().includes(searchValue.toLowerCase()))
        : optionsList, [optionsList, searchValue]);
    (0, react_1.useLayoutEffect)(() => {
        rowRef.current.scrollLeft = refRowContent.current.clientWidth;
    }, [value]);
    (0, react_1.useEffect)(() => {
        const inputElement = inputRef.current;
        const handleEvent = (event) => {
            if (event.keyCode === SPACE_KEY_CODE) {
                event.preventDefault();
            }
        };
        inputElement.addEventListener('keydown', handleEvent);
        return () => inputElement.removeEventListener('keydown', handleEvent);
    }, []);
    (0, react_1.useEffect)(() => {
        if (!isOpen) {
            setSortedOptions(cachedOptionsList);
            clearSearch();
        }
    }, [isOpen, value, cachedOptionsList]);
    (0, react_1.useEffect)(() => {
        if (isOpen && !optionsList.length && !isOptionsLoading) {
            setOptionsList(cachedOptionsList);
        }
    }, [isOpen, isOptionsLoading, optionsList, cachedOptionsList]);
    const handleOptionClick = (option) => {
        const selectedOptions = value ? [...value] : [];
        const { label: optionLabel, value: optionValue, description } = option;
        const selectedIdx = selectedOptions.findIndex((item) => item.value === optionValue);
        if (selectedIdx !== -1) {
            selectedOptions.splice(selectedIdx, 1);
        }
        else {
            selectedOptions.push(Object.assign({ label: optionLabel, value: optionValue }, (description ? { description } : {})));
        }
        onChange(selectedOptions);
        updateOptionsValue(selectedOptions);
        clearSearch();
    };
    const updateOptionsValue = (selectedOptions = []) => {
        const source = !!searchValue ? cachedOptionsList : optionsList;
        const list = (source === null || source === void 0 ? void 0 : source.map((option) => (Object.assign(Object.assign({}, option), { selected: selectedOptions.some(({ value: optionValue }) => optionValue === option.value) })))) || [];
        if (!!searchValue) {
            setSortedOptions(list);
        }
        else {
            setOptionsList(list);
        }
    };
    const handleKeyDown = (e) => {
        if (e.keyCode === DELETE_KEY_CODE &&
            inputRef.current.value === '' &&
            (value === null || value === void 0 ? void 0 : value.length) > 0) {
            handleClearChoice(value[value.length - 1].value);
        }
    };
    const clearSearch = () => {
        inputRef.current.value = '';
        setSearchValue('');
    };
    const handleInputChange = (val) => {
        var _a, _b, _c;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.setSelectionRange(((_b = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _b === void 0 ? void 0 : _b.value.length) + 1, ((_c = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _c === void 0 ? void 0 : _c.value.length) + 1);
        setSearchValue(val);
    };
    const handleClickOutside = (e) => {
        if (tokenInputContainerRef.current &&
            !tokenInputContainerRef.current.contains(e.target) &&
            document.activeElement !== (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) {
            setIsOpen(false);
            setHasFocusedStyle(false);
        }
    };
    const handleSelectSuggestion = (suggestion) => {
        const option = optionsList.find((option) => option.value === suggestion.value);
        if (option) {
            handleOptionClick(option);
        }
        return suggestion;
    };
    const handleClearChoice = (value) => {
        const option = cachedOptionsList.find((option) => option.value === value);
        if (option) {
            handleOptionClick(option);
        }
        return value;
    };
    (0, react_1.useEffect)(() => {
        document.addEventListener('click', handleClickOutside);
        document.addEventListener('focusin', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
            document.removeEventListener('focusin', handleClickOutside);
        };
    }, []);
    const setSortedOptions = (0, react_1.useCallback)((options) => {
        const sortedList = [...options].sort((a, b) => a.selected === b.selected ? 0 : a.selected ? -1 : 1);
        setOptionsList(sortedList);
    }, []);
    const onfocusHandled = () => {
        setIsOpen(true);
    };
    const tokenInputHandler = (e) => {
        const optionsContainer = optionsContainerRef.current;
        const inputElement = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current;
        onfocusHandled();
        if (optionsContainer &&
            optionsContainer.contains(e.target) &&
            window.matchMedia('(max-width: 1024px)').matches) {
            return;
        }
        inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus();
        setHasFocusedStyle(true);
        inputElement === null || inputElement === void 0 ? void 0 : inputElement.setSelectionRange(inputElement === null || inputElement === void 0 ? void 0 : inputElement.value.length, inputElement === null || inputElement === void 0 ? void 0 : inputElement.value.length);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(helper_text_1.HelperText, { status: error ? 'error' : undefined, message: !isOpen && (hintObject === null || hintObject === void 0 ? void 0 : hintObject.message) },
            react_1.default.createElement(token_input_styles_1.TokenInputContainer, { ref: tokenInputContainerRef, onClick: tokenInputHandler, error: error, isFocused: document.activeElement === (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) || hasFocusedStyle, isNotEmpty: !!(value === null || value === void 0 ? void 0 : value.length) },
                react_1.default.createElement(token_input_styles_1.TokenLabel, { error: error, isNotEmpty: !!(value === null || value === void 0 ? void 0 : value.length) || document.activeElement === (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) }, label),
                react_1.default.createElement(token_input_styles_1.TokenRow, { ref: rowRef },
                    react_1.default.createElement(token_input_styles_1.TokenRowContent, { ref: refRowContent }, value === null || value === void 0 ? void 0 :
                        value.map((item) => (react_1.default.createElement(components_1.ChoiceItem, { key: item.value, index: item.value, clearCb: handleClearChoice, label: item.label, isFocused: document.activeElement === (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) ||
                                hasFocusedStyle, testId: `${testId}.choiceItem` }))),
                        react_1.default.createElement(token_input_styles_1.InputWrap, null,
                            react_1.default.createElement(input_1.Input, { ref: inputRef, noMargin: noMargin, onChange: handleInputChange, onKeyDown: handleKeyDown, onFocus: onfocusHandled, error: error, disabled: disabled, autoComplete: "off", style: {
                                    borderRadius: 0,
                                    background: 'transparent',
                                    height: 20,
                                    padding: 0,
                                    minWidth: document.activeElement === (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) ||
                                        hasFocusedStyle
                                        ? 40
                                        : 0,
                                    width: `calc(${(_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length} * 12px + ${document.activeElement === (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) ||
                                        hasFocusedStyle
                                        ? 15
                                        : 0}px)`,
                                }, "data-testid": `${testId}.input` })))),
                isOpen && (react_1.default.createElement(token_input_styles_1.OptionsContainer, { isStaticOptions: isStaticOptions, ref: optionsContainerRef },
                    react_1.default.createElement(options_1.Options, { options: filteredOptions, onOptionClick: handleOptionClick, isLoading: isOptionsLoading, testId: `${testId}.options`, isMultiSelect: true }))))),
        suggestions && (react_1.default.createElement(token_input_styles_1.SuggestionContainer, null,
            react_1.default.createElement(suggestions_1.Suggestions, { suggestions: suggestions, onSelectSuggestion: handleSelectSuggestion })))));
};
exports.TokenInput = TokenInput;
